<script setup>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { EventManager, Actions, ChangeSectionPayload } from "@events";
import { SectionList } from "@module-system";

const props = defineProps({
  rtcId: String,
});

function openPhoto() {
  EventManager.getActionEmitter(props.rtcId).emit("open-transfer-start-modal");
}
</script>

<template>
  <VideoCallButton icon="mdi-account-switch" @click="openPhoto" />
</template>
